import api from "@/lib/api";

export default {
    urlGetAll: "/api/v1/financial/bank-account/get-all",
    urlCreate: "/api/v1/financial/bank-account/create",
    urlUpdate: "/api/v1/financial/bank-account/update",
    urlDelete: "/api/v1/financial/bank-account/delete",
    urlGetById: "/api/v1/financial/bank-account/get-by-id",
    urlGetCompanyPlan: "/api/v1/adm/company/get-plan",
    urlGetConnectToken: "/api/v1/finance/bank-account/get-connect-token",
    urlUpdatePluggyId: "/api/v1/finance/bank-account/update-pluggyId",
    urlDisconnectAccount: "/api/v1/finance/bank-account/disconnect-account",

    async getAll() {
        const response = await api.get(this.urlGetAll, {
            params: { search: "", filter: "contains", currentPage: 1, totalPerPage: 1000 },
        });
        return response.data;
    },
    async remove(ids) {
        const response = await api.post(this.urlDelete, { ids });
        return response.data;
    },
    async getById(id) {
        const response = await api.get(this.urlGetById, { params: { id } });
        return response.data;
    },
    async create(model) {
        const response = await api.post(this.urlCreate, model, { showSuccessToast: true });
        return response.data;
    },
    async update(model) {
        const response = await api.post(this.urlUpdate, model, { showSuccessToast: true });
        return response.data;
    },
    async getCompanyPlan() {
        const response = await api.get(this.urlGetCompanyPlan);
        return response.data;
    },
    async getConnectToken() {
        const response = await api.get(this.urlGetConnectToken);
        return response.data;
    },
    async updatePluggyId(id, pluggyItemId) {
        const response = await api.put(this.urlUpdatePluggyId, { id, any: pluggyItemId });
        return response.data;
    },
    async disconnectAccount(id) {
        const response = await api.put(this.urlDisconnectAccount, { id });
        return response.data;
    },
};
